import axios from '@/plugins/axios'

const state = {
  blueprint: {
    show: false,
    radar: 0,
    quadrant: 0,
    sector: 0,
    blobId: 0,
    name: '',
    copy: false,
  },
  linking: {
    show: false
  }
}

// getters
const getters = {
  getLinking: state => {
    return state.linking
  },
}

// actions
const actions = {
  async copyBlob({ commit }, settings) {
    // set loader
    commit('addToLoadingQueue', 'linking_copy_blob',  { root: true });

    return new Promise((resolve, reject) => {
      // send create request
      axios.post('/suggestions/copy-blob', settings)
        .then((response) => {

          commit('blobs/setBlob', response.data.blob,  { root: true })
          commit('suggestion/incBlobCounter', settings.blobId,  { root: true })

          // remove loader
          commit('removeFromLoadingQueue', 'linking_copy_blob', { root: true });

          resolve(response);
        })
        .catch((error) => {
          // remove loader
          commit('removeFromLoadingQueue', 'linking_copy_blob', { root: true });
          // raise error
          commit('error/newError', {
            title: 'error.linking.blob.create',
            text: error.response? error.response.data.message || error.message: error.message
          }, { root: true});

          reject(error);
        })
    });
  },

  async followBlob() {

  }
}

// mutations
const mutations = {
  newLinking (state, settings) {
    settings.show = true;
    state.linking = Object.assign(state.blueprint, settings);
  },

  closeLinking (state) {
    state.linking.show = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
